import { useTheme } from 'vuetify'

interface ColorOptions {
	/**
	 * Luminance threshold for determining if a color is light (0-1)
	 * @default 0.5
	 */
	threshold?: number
}

/**
 * Determines if a color is light or dark using Vuetify's theme utilities
 * @param options - Configuration options
 * @returns Object containing lightOrDark function
 */
export function useLightOrDark(options: ColorOptions = {}) {
	const defaultOptions: Required<ColorOptions> = {
		threshold: 0.5,
	}

	/**
	 * Determine if a color is light or dark using Vuetify's theme utilities
	 * @param color - Color value (hex, rgb, or hsl)
	 * @returns True if color is light, false if dark
	 */

	const lightOrDark = (color: string): boolean => {
		color = color.toString()
		let r: number, g: number, b: number, hsp: number
		if (color?.match(/^rgb/)) {
			color = color.match(
				/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
			)!
			r = parseInt(color[1], 10)
			g = parseInt(color[2], 10)
			b = parseInt(color[3], 10)
		} else {
			r = parseInt(color.slice(1, 3), 16)
			g = parseInt(color.slice(3, 5), 16)
			b = parseInt(color.slice(5, 7), 16)
		}
		hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))
		return hsp > 127.5
	}

	return {
		lightOrDark,
	}
}

export type { ColorOptions }
